import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import quote from "svg/quote.svg";
import { useParams, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Modal from "common/modal";
import { bulkUpdateSiteProducts } from "store/siteRepo/actionCreator";
import { toast } from "react-toastify";
import ProductDisplay from "./ProductDisplay";
import "./style.scss";

const Confirmation = ({ productsData, setStage }) => {
  const dispatch = useDispatch();
  const { siteId } = useParams();
  const navigate = useNavigate();
  const [confirmationProductData, setConfirmationProductData] = useState([]);
  const [confirmationLayerData, setConfirmationLayerData] = useState([]);
  const [isSelectAllCheckedLayer, setIsSelectAllCheckedLayer] = useState(true);
  const [isShowSaveModal, setIsShowSaveModal] = useState(false);
  const [isBulkEditDisabled, setIsBulkEditDisabled] = useState(false);
  const { viewSite } = useSelector((state) => state.siteRepo);
  const { sub } = useSelector((state) => state.loggedInUser);
  const { projectDetailsList, siteName } = viewSite;

  useEffect(() => {
    let confirmationProdData = [];
    productsData.map((product) => {
      if (product.newProductId || product.laborCodesArr.length > 0 || product.isManualProduct) {
        confirmationProdData.push(product);
      }
    });
    setConfirmationProductData(confirmationProdData);
  }, [productsData]);

  useEffect(() => {
    let layerData = [];
    let tempData = JSON.parse(JSON.stringify(projectDetailsList));
    confirmationProductData.map((ele) => {
      tempData?.map((project) => {
        project.layerInfoList.map((layer) => {
          layer.projectName = project.name;
          layer.rooms.map((room) => {
            if (ele.isManualProduct === true && room.products.length === 0) {
              layerData.push(layer);
            } else {
              room.products.map((product) => {
                if (
                  (product.id?.trim() === ele.id?.trim() ||
                    ele.isManualProduct === true ||
                    (product.salesNumber === ele.salesNumber &&
                      product.salesNumber !== null &&
                      ele.salesNumber !== null)) &&
                  !layerData.includes(layer)
                ) {
                  layerData.push(layer);
                }
              });
            }
          });
          if (layer.rooms.length == 0) {
            layerData.push(layer);
          }
        });
      });
    });

    let finalLayerData = [];
    layerData.map((layer) => {
      if (!finalLayerData.includes(layer)) {
        finalLayerData.push(layer);
      }
    });
    finalLayerData.map((layer, index) => {
      layer.isLayerSelected = true;
      layer.elementIndex = index;
    });
    setConfirmationLayerData(finalLayerData);
  }, [projectDetailsList, confirmationProductData]);

  useEffect(() => {
    const tempArr = confirmationLayerData.filter((element) => element.isLayerSelected == true);
    if (tempArr.length) {
      setIsBulkEditDisabled(false);
    } else {
      setIsBulkEditDisabled(true);
    }
  }, [confirmationLayerData]);

  const confirmBulkUpdate = () => {
    let finalLayerList = [];
    confirmationLayerData?.map((layer) => {
      if (layer.isLayerSelected) {
        let temp = {};
        (temp["layerId"] = layer.layerId), (temp["projectId"] = layer.projectId), (temp["bulkUpdateProductList"] = []);
        finalLayerList.push(temp);
        if (!finalLayerList.includes(layer.layerId)) {
          layer.rooms.map((room) => {
            room.products.map((product) => {
              confirmationProductData.map((ele) => {
                if (
                  product?.id === ele?.id ||
                  (product.salesNumber === ele.salesNumber &&
                    product.salesNumber !== null &&
                    ele.salesNumber !== null &&
                    !product.isManualProduct)
                ) {
                  const productLaborCodes = product.siteLaborCodes?.length
                    ? product.siteLaborCodes?.map((item) => item.laborCode)
                    : [];
                  let obj = {};
                  obj["productId"] = product.roomInfoId;
                  obj["oldSalesNumber"] = ele.salesNumber == null ? "" : ele.salesNumber;
                  obj["newSalesNumber"] = ele.newSalesNumber
                    ? ele.newSalesNumber
                    : ele.salesNumber == null
                      ? ""
                      : ele.salesNumber;
                  obj["oldProductName"] = ele.id;
                  obj["newProductName"] = ele.newProductId ? ele.newProductId : ele.id;
                  obj["oldProductType"] = ele.type;
                  obj["newProductType"] = ele.newType ? ele.newType : ele.type;
                  obj["oldCategoryCode"] = ele.categoryCode;
                  obj["newCategoryCode"] = ele.newCategoryCode ? ele.newCategoryCode : ele.categoryCode;
                  obj["createdBy"] = sub;
                  obj["updatedBy"] = sub;
                  obj["unit"] = product.unit;
                  obj["laborCodeRequestList"] = ele.laborCodesArr.map((item) => ({
                    laborCodeId: item.id,
                    quantity:
                      item.matchProdQuantity === "false" ||
                      (item.matchProdQuantity === "true" && item.unitType === "true" && product.unit !== "EA")
                        ? "0"
                        : parseFloat(product.actualUsage).toFixed(2).toString(),
                    updatedBy: sub,
                    isTaxable: item.isTaxable,
                  }));

                  if (ele.id === ele.newProductId) {
                    obj["oldSalesNumber"] = "";
                    obj["oldProductName"] = "";
                    obj["oldProductType"] = "";
                    obj["oldCategoryCode"] = "";
                  }
                  temp.bulkUpdateProductList.push(obj);
                }
              });
            });
          });
        }
      }
    });

    confirmationProductData.map((ele) => {
      if (ele.isManualProduct) {
        finalLayerList.map((item) => {
          let obj = {};
          obj["productId"] = "";
          obj["oldSalesNumber"] = "";
          obj["newSalesNumber"] = ele.newSalesNumber;
          obj["oldProductName"] = "";
          obj["newProductName"] = ele.newProductId;
          obj["oldProductType"] = "";
          obj["newProductType"] = ele.newType;
          obj["actualUsage"] = "0";
          obj["oldCategoryCode"] = "";
          obj["newCategoryCode"] = ele.newCategoryCode;
          obj["createdBy"] = sub;
          obj["updatedBy"] = sub;
          obj["laborCodeRequestList"] = ele.laborCodesArr?.map((laborCode) => ({
            laborCodeId: laborCode.id,
            quantity: "0",
            updatedBy: sub,
          }));
          item.bulkUpdateProductList.push(obj);
        });
      }
    });

    const payload = [
      {
        siteId: siteId,
        siteName: siteName,
        bulkUpdateLayerDtoList: finalLayerList,
      },
    ];

    toast
      .promise(dispatch(bulkUpdateSiteProducts(payload, siteId)), {
        pending: "Updating products.",
        success: "Products updated successfully!",
        error: "Something went wrong. Please try again.",
      })
      .then((res) => {
        setIsShowSaveModal(false);
        navigate(`/siteRepo/site/${siteId}`);
      });
  };

  const handleLayerSelection = (layerId) => {
    const bulkEditTableListNew = JSON.parse(JSON.stringify(confirmationLayerData));
    bulkEditTableListNew.map((item) => {
      if (item.layerId === layerId) {
        item.isLayerSelected = item.isLayerSelected ? false : true;
      }
    });
    setConfirmationLayerData(bulkEditTableListNew);
  };

  const handleSelectAllLayers = () => {
    let isAllLayerChecked = isSelectAllCheckedLayer;
    const bulkEditTableList = JSON.parse(JSON.stringify(confirmationLayerData));

    if (isSelectAllCheckedLayer) {
      confirmationLayerData.map((user) => {
        bulkEditTableList[user.elementIndex].isLayerSelected = false;
      });
      isAllLayerChecked = false;
    } else {
      confirmationLayerData.map((user) => {
        bulkEditTableList[user.elementIndex].isLayerSelected = true;
      });
      isAllLayerChecked = true;
    }
    setConfirmationLayerData(bulkEditTableList);
    setIsSelectAllCheckedLayer(isAllLayerChecked);
  };

  return (
    <>
      <div className="container-fluid search-form-container">
        <div className="search-form-container__title">
          <span className="search-form-container__title--text">
            <img src={quote} alt="quote" />
            &nbsp;Bulk Update confirmation
          </span>
        </div>

        {confirmationProductData.map((product, index) => (
          <div
            key={index + product?.categoryCode + product?.roomInfoId}
            className="product-view bulk-product-container bg-light"
          >
            <div className="d-flex">
              {!product.isManualProduct && (
                <div className="border rounded p-2 m-2 bg-white" style={{ width: "calc(50% - 16px)" }}>
                  <div className="d-flex item-header mb-2">Current Product</div>
                  <ProductDisplay number={product?.salesNumber} name={product?.id} category={product?.type} />
                </div>
              )}
              {product.newSalesNumber && (
                <div className="border rounded p-2 m-2 bg-white" style={{ width: "calc(50% - 16px)" }}>
                  <div className="d-flex item-header mb-2">
                    <span className="highlight">{product.isManualProduct ? "New" : "Replacement"} Product</span>
                  </div>
                  <ProductDisplay
                    number={product?.newSalesNumber}
                    name={product?.newProductId}
                    category={product?.newType}
                  />
                </div>
              )}
            </div>
            {product?.laborCodesArr?.map((laborCodeItem, itemIndex) => (
              <div
                className="d-flex align-items-center py-2 ms-5"
                key={itemIndex + laborCodeItem.id}
                style={{ borderBottom: "1px solid #d1d1d1", marginBottom: -1, width: "fit-content" }}
              >
                <div className="pe-2" style={{ borderRight: "1px solid #d1d1d1", width: 40 }}>
                  {laborCodeItem.laborCode}
                </div>
                <div className="px-2" style={{ borderRight: "1px solid #d1d1d1", width: 450 }}>
                  {laborCodeItem.description ?? "NA"}
                </div>
                <label className="px-2 d-flex align-items-center">
                  <input className="me-2" type="checkbox" defaultChecked={laborCodeItem.isTaxable} disabled />
                  taxable
                </label>
              </div>
            ))}
          </div>
        ))}
        <div className="floorList-table">
          <div className="floor-dets">
            <span className="floor-dets--text">Floors (layers)</span>
          </div>
          {confirmationLayerData?.length > 0 && (
            <div className="d-flex col-12">
              <div className={`d-flex col-lg-2 col-md-4 align-items-center`}>
                <span className="checkbox-header-label">
                  <input
                    type="checkbox"
                    aria-label="Checkbox select all of rows"
                    className="checkbox-header--input"
                    checked={isSelectAllCheckedLayer}
                    onChange={handleSelectAllLayers}
                  />
                </span>
                Select All
              </div>
            </div>
          )}
          <div className="floorList-table">
            {confirmationLayerData.map((layer, index) => (
              <div className="d-flex floor-item" key={index + layer.layerId}>
                <div className="d-flex">
                  <input
                    type="checkbox"
                    aria-label="Checkbox selection of rows"
                    className="checkbox-header--input"
                    checked={layer.isLayerSelected}
                    onChange={() => handleLayerSelection(layer.layerId)}
                  />
                </div>
                <div className="d-flex ">
                  <span className="floor-name">{`${layer.name} - ${layer.projectName}`}</span>
                </div>
              </div>
            ))}
          </div>
          <div className="d-flex footer_display justify-content-between flex-column flex-md-row">
            <Button variant="outline-primary" onClick={() => setStage("product")}>
              Back
            </Button>
            <Button onClick={() => setIsShowSaveModal(true)} disabled={isBulkEditDisabled}>
              Confirm Bulk Update
            </Button>
          </div>
        </div>
      </div>

      {isShowSaveModal && (
        <Modal
          title={"Save Changes"}
          handleSave={confirmBulkUpdate}
          handleCancel={() => setIsShowSaveModal(false)}
          size={"lg"}
          sectionName={""}
          closeButtonText={"Cancel"}
          saveButtonText={"Save"}
        >
          <>
            <p className="confirmation-text">Are you sure you want to update products/labor codes in site?</p>
          </>
        </Modal>
      )}
    </>
  );
};

export default Confirmation;
